<template>
  <div>
    <div class="table__wrap">
      <div class="yaoyue__nav">
        <el-row>
                <!--<el-col :span="6">状态：
                  <el-select v-model="value" placeholder="请选择" clearable size="small" @change="getYaoYueData">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                 </el-col>-->
                 <el-col :span="12"><span style="float:left;margin-top:12px;margin-right:5px">部门：</span>
                   <DepartmentCascade  size="small" ref="cascadeOne" v-bind:first="parentMsgOne" v-on:getDepartmentOne="showDepartmentOne4" v-bind:second="parentMsgTwo" v-on:getDepartmentTwo="showDepartmentTwo4" v-bind:third="parentMsgThree" v-on:getDepartmentThree="showDepartmentThree4"
                   v-bind:four="parentMsgFour" v-on:getDepartmentFour="showDepartmentFour4"></DepartmentCascade>

                </el-col>
                <el-col :span="12">
                    操作人：
                    <el-select v-model="value1" placeholder="请选择" clearable size="small" @change="getYaoYueData">
                      <el-option
                        v-for="item in options1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>

                </el-col>
              </el-row>
      </div>
      <div class="yaoyue__length"></div>
      <div class="yaoyue__content">
        <el-table :data="currentData">
              <el-table-column prop="jianli_name" label="姓名" align="center"></el-table-column>
              <el-table-column prop="jianli_mobile" label="手机" align="center" ></el-table-column>
              <el-table-column prop="jianli_email" label="邮箱" align="center"></el-table-column>
              <el-table-column prop="jianli_xuexiao" label="学校" align="center"></el-table-column>
              <el-table-column prop="jianli_xueli" label="学历" align="center"></el-table-column>
              <el-table-column prop="jianli_gender" label="性别" align="center"></el-table-column>
              <el-table-column prop="jianli_age" label="年龄" align="center"></el-table-column>
              <el-table-column  label="应聘岗位" align="center"  width="200">
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="top">
                    <p v-if="scope.row.list!='万丈金数'">{{ scope.row.list }}</p>
                    <p v-else >无来源数据</p>
                    <div slot="reference" >
                      <el-button size="medium" type="text" style="color:#333333;">{{ scope.row.zhiwei }}</el-button>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="jianli_laizi" label="来源" align="center"></el-table-column>
              <el-table-column prop="newStatus" label="状态" align="center"></el-table-column>
              <el-table-column prop="handle" label="操作" align="center">
                <template slot-scope="scope">
                  <span @click="go((scope.row.jianli_id))" style="cursor: pointer;color: #1989fa;">查看简历</span>
                </template>
              </el-table-column>
              <el-table-column prop="action_name" label="操作者" align="center"></el-table-column>
              <el-table-column prop="" label="" align="center">
                <template slot-scope="scope">
                  <span @click="getHistoryDetail(scope.row.jianli_id)" style="cursor: pointer;">历史操作</span>
                </template>
              </el-table-column>
            </el-table>
      </div>
      <div class="yaoyue__pagination">
        <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :page-sizes="pageSizes"
              layout="total,sizes,prev, pager, next"
              :total="totalList">
            </el-pagination>
      </div>
    </div>
    <!-- 操作历史弹层 -->
    <el-dialog
      title=""
      :visible.sync="centerDialogVisible"
      width="80%"
      center>
      <span>
        <el-table :data="histableData" style="width: 100%">
          <el-table-column
            prop="hisotry_name"
            label="操作人"
            width="180">
          </el-table-column>
          <el-table-column
            prop="history_time"
            label="操作时间"
            width="180">
          </el-table-column>
          <el-table-column
            prop="newAction"
            label="干了什么">
          </el-table-column>
          <el-table-column
            prop="history_talk"
            label="备注">
          </el-table-column>
        </el-table>
      </span>
    </el-dialog>
    <!-- 弹层end -->
  </div>
</template>

<style lang="scss" scoped>
.title {
  font-size: 12px;
  color: #999999;
}

.table {
  &__wrap {
    // margin-top: 20px;
    border-radius: 3px;
    background-color: rgba(255, 255, 255, 1);
    overflow: hidden;
  }
  &__nav {
    font-size: 16px;
    margin-bottom: 0; // padding-bottom: 1px;
    box-shadow: 0px 1px 0px 0px rgba(233, 233, 233, 1);
    a#{&}--active {
      color: rgba(255, 96, 2, 1);
      box-shadow: 0px 2px 0px 0px rgba(255, 96, 2, 1);
    }
    a {
      display: inline-block;
      text-decoration: none;
      line-height: 21px;
      font-size: 16px;
      text-align: center;
      padding: 10px 20px;
      text-align: center;
      color: #333333;
      span {
        color: rgba(0, 0, 0, 0.65);
        font-size: 12px;
        text-align: left;
        border-radius: 40px;
        border: 1px #d9d9d9 solid;
        padding: 0px 5px;
        margin-left: 5px;
        font-family: HelveticaNeue;
      }
    }
  }
  &__list {
    margin: 0px 20px 0 20px;
    border: 1px solid #e9e9e9;
  }
}
.yaoyue__nav {
  padding: 20px;
  font-size: 14px;
}
.yaoyue {
  &__length {
    border-bottom: 1px solid #e9e9e9;
  }
  &__content {
    margin: 20px 24px 0 24px;
    border: 1px solid #e9e9e9;
  }
  &__pagination {
    clear: both;
    float: right;
    padding: 10px;
  }
}
</style>
<script>
import DepartmentCascade from '../components/DepartmentCascade.vue'
export default {
  data () {
    return {
      firstApart: '',
      mianshi: '',
      bannerData: {},
      activeName: 'first',
      centerDialogVisible: false,
      tableData: [],
      currentData: [],
      navIndex: 0,
      pageSize: 10,
      pageNum: 1,
      pageSizes: [10, 20, 50],
      totalList: 0,
      labelPosition: 'left',
      // options: [
      //   {
      //     value: "-1",
      //     label: "删除"
      //   },
      //   {
      //     value: "0",
      //     label: "未处理"
      //   },
      //   {
      //     value: "1",
      //     label: "可邀约"
      //   },
      //   {
      //     value: "2",
      //     label: "不合适"
      //   },
      //   {
      //     value: "3",
      //     label: "已邀约"
      //   },
      //   {
      //     value: "4",
      //     label: "爽约"
      //   },
      //   {
      //     value: "5",
      //     label: "已面试"
      //   },
      //   {
      //     value: "6",
      //     label: "通过"
      //   },
      //   {
      //     value: "7",
      //     label: "发offer"
      //   },
      //   {
      //     value: "8",
      //     label: "放弃入职"
      //   },
      //   {
      //     value: "9",
      //     label: "入职"
      //   },
      //   {
      //     value: "10",
      //     label: "上传"
      //   },
      //   {
      //     value: "11",
      //     label: "内推"
      //   },
      //   {
      //     value: "10001",
      //     label: "修改"
      //   }
      // ],
      // value: "",
      options1: [
        {
          value: '1',
          label: '全部'
        },
        {
          value: '2',
          label: '不是我操作的'
        },
        {
          value: '3',
          label: '是我操作的'
        }
      ],
      value1: '',
      selectedOptions2: [],
      formLabelAlign: {
        name: '',
        selectedOptions: [],
        num: '',
        content: ''
      },
      parentMsgOne: '',
      parentMsgTwo: '',
      parentMsgThree: '',
      parentMsgFour: '',
      secondApart: '',
      thirdApart: '',
      forthApart: '',
      histableData: []
    }
  },
  components: {
    DepartmentCascade
  },
  created () {
    this.getYaoYueData()
  },
  methods: {
    getYaoYueData () {
      let self = this
      // 请求jianli列表接口
      // var b = 1;
      this.$axios
        .post('/api/zhaopin/yaoyue2', {
          // a: b
          jianli_status_id: this.value,
          action: this.value1,
          jiagou_first: this.firstApart,
          jiagou_second: this.secondApart,
          jiagou_third: this.thirdApart,
          jiagou_forth: this.forthApart
        })
        .then(function (response) {
          self.totalList = response.data.number
          self.tableData = response.data.zhiwei_data
          for (var i = 0; i < self.totalList; i++) {
            var status = self.tableData[i]['status']
            var jianli_atime = self.tableData[i]['jianli_atime']
            var nstatus
            var first_name = self.tableData[i]['jiagou_first_name']
            var second_name = self.tableData[i]['jiagou_second_name']
            var third_name = self.tableData[i]['jiagou_third_name']
            var forth_name = self.tableData[i]['jiagou_forth_name']
            switch (status) {
              case '-1':
                nstatus = '删除简历'
                break
              case '0':
                nstatus = '未处理'
                break
              case '1':
                nstatus = '可邀约'
                break
              case '2':
                nstatus = '不合适'
                break
              case '3':
                nstatus = '已邀约'
                break
              case '4':
                nstatus = '爽约'
                break
              case '5':
                nstatus = '已面试'
                break
              case '6':
                nstatus = '通过'
                break
              case '7':
                nstatus = '发offer'
                break
              case '8':
                nstatus = '放弃入职'
                break
              case '9':
                nstatus = '入职'
                break
              case '10':
                nstatus = '上传'
                break
              case '11':
                nstatus = '内推'
                break
              case '12':
                nstatus = '邀约失败'
                break
              case '-2':
                nstatus = '不通过'
                break
              case '-3':
                nstatus = '人才库'
                break
              case '10001':
                nstatus = '修改'
                break
            }
            // var third_name = self.tableData[i]["jiagou_third_name"];
            // self.tableData[i].zhiwei_zhiding = Math.round(Math.random() * 1);
            self.tableData[i].newStatus = nstatus + '(' + jianli_atime + ')'
            if (
              (second_name === '') &
              (third_name == '') &
              (forth_name == '')
            ) {
              self.tableData[i].list = first_name
            } else if ((third_name == '') & (forth_name == '')) {
              self.tableData[i].list = first_name + '/' + second_name
            } else if (forth_name == '') {
              self.tableData[i].list =
                first_name + '/' + second_name + '/' + third_name
            } else {
              self.tableData[i].list =
                first_name +
                '/' +
                second_name +
                '/' +
                third_name +
                '/' +
                forth_name
            }
          }
          self.getCurrentList()
        })
    },
    nav (index) {
      this.navIndex = index
    },
    getCurrentList () {
      this.currentData =
        this.tableData &&
        this.tableData.slice(
          (this.pageNum - 1) * this.pageSize,
          this.pageNum * this.pageSize
        )
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getCurrentList()
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.getCurrentList()
    },

    showDepartmentOne4: function (one) {
      let self = this
      this.firstApart = one
      self.getYaoYueData()
    },
    showDepartmentTwo4: function (two) {
      let self = this
      this.secondApart = two
      self.getYaoYueData()
    },
    showDepartmentThree4: function (three) {
      let self = this
      this.thirdApart = three
      self.getYaoYueData()
    },
    showDepartmentFour4 (four) {
      let self = this
      this.forthApart = four
      self.getYaoYueData()
    },
    go (jianli_id) {
      // let self = this;
      sessionStorage.setItem('jianli_id', jianli_id)
      // self.$router.push("/Auditing");
      window.open('/Auditing')
    },
    getHistoryDetail (id) {
      let self = this
      this.$axios
        .post('/api/zhaopin/zhiwei/detail2', {
          jianli_id: id
        })
        .then(function (res) {
          self.centerDialogVisible = true
          self.histableData = res.data.data
          for (var i = 0; i < self.histableData.length; i++) {
            var action = self.histableData[i]['history_action']
            var time = self.histableData[i]['history_atime']
            self.histableData[i].newAction = action + '(' + time + ')'
          }
        })
    }
  }
}
</script>
